// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 796 ? "gtm-module" : chunkId) + "." + {"156":"3fe15603","251":"2c1780b1","331":"9c1a6771","471":"e1b0a00b","522":"2a69ec71","552":"94f7ecfc","796":"8917dccf","873":"8746e80c"}[chunkId] + ".chunk.js";
};